import { render, staticRenderFns } from "./UserTagKeysList.vue?vue&type=template&id=4d5a7beb&"
import script from "./UserTagKeysList.vue?vue&type=script&lang=js&"
export * from "./UserTagKeysList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports